import SubscriptionConstants from 'client/Payments/pricingMatrix/SubscriptionConstants';

const {
  getProductCodeByType,
  SubscriptionTypes,
} = SubscriptionConstants;

/**
 * Add ons sometimes have a "special" price that is used when it is
 * being applied as an add on instead of a component of an alacarte purchase.
 * This method outputs the correct price for a given addon/component based
 * on given inputs.
 */
export default function getAddOnPrice(addOn, isAnnual, productCode) {
  const isALaCarte = productCode === getProductCodeByType(SubscriptionTypes.alaCarte);
  const addOnPrice = isAnnual
    ? addOn.specialAddOnAnnualPrice || addOn.annualPrice
    : addOn.specialAddOnMonthlyPrice || addOn.listPrice;
  const aLaCartePrice = isAnnual
    ? addOn.annualPrice
    : addOn.listPrice;

  return isALaCarte ? aLaCartePrice : addOnPrice;
}
